import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../enquiry/enquiry.scss";
import FetchData, { DeleteEntry, GetList } from "../../providers/dataProvider";
import { compareDates, convertLocalToUTCDate, formatDate } from "../../utils/Validate";
import DataSearch from "../../utils/DataSearch";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import DatePicker from "react-datepicker";
import DataFilter from "../../utils/DataFilter";
import { useRolePermission } from "../../hooks/useRolePermission";
import DeleteModal from "../../components/common/DeleteModal";
import EnquiryDataGrid from "../../components/enquiry/EnquiryDataGrid";
import { SearchComponent } from "../../components/common/SearchComponent";
import EnquiryFilter from "../../components/enquiry/EnquiryFilter";
import ErrorMessage from "../../components/common/ErrorMessage";
import { CheckNull } from '../../utils/Validate';
import { ErrorMessages, SuccessMessages } from "../../constants/MessageConstants";
import AdvancedFilterDropdown from "../../components/common/AdvancedFilterDropdown";
import { PlaceHolder } from "../../constants/PlaceHolderConstants";
import { getStorageData } from "../../utils/Validate";

const EnquiryList = () => {

  const navigate = useNavigate();
  const [createMsg, setCreateMsg] = useState(null);
  const [projectData, setProjectData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [assignedEngineerData, setAssignedEngineerData] = useState([]);
  const [successShow, setSuccessShow] = useState(false)
  const [deleteShow, setDeleteShow] = useState({
    show: false,
    item: "",
    title: "",
    textCode: "",
    text: "",
    loading: false,
  });

  const [errorShow, setErrorShow] = useState({ show: false, errorMessage: "" });
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState([]);
  const [refreshData, setRefreshData] = useState([]);
  const [filterColumn, setFilterColumn] = useState([]);
  const [selected, setSelected] = useState([]);
  const [projectName, setProjectName] = useState([]);
  const [customerName, setCustomerName] = useState([]);
  const [distributorName, setDistributorName] = useState([]);
  const [projectReference, setProjectReference] = useState([]);
  const [allocatedToName, setAllocatedToName] = useState([]);

  const [InquiryFilter, setInquiryFilter] = useState({
    projectName: [],
    customerName: [],
    distributorName: [],
    projectReference: [],
    allocatedToName: [],
    status: [],
    dateFilter: [],
  });
  const [clrFilter, setClrFilter] = useState(false);
  const [refreshSearch, setRefreshSearch] = useState(false);
  let todate = new Date();
  let prvDate = new Date(
    todate.getFullYear(),
    todate.getMonth() - 1,
    todate.getDate()
  );
  const [dateRange, setDateRange] = useState([null, null]);
  const { menuRights } = useRolePermission("Enquiry");
  const [customerInquiryData, setCustomerInquiryData] = useState([]);

  const { data: InquiryList, loading: loadingList } = FetchData("inquiry");
  const { data: customerList } = FetchData("Customer");
  const { data: distributorList } = FetchData("distributor");
  const baseColumns = [
    {
      heading: "Enquiry Ref",
      value: "inquiryRef",
      sortable: true,
    },
    {
      heading: "Enquiry Date",
      value: "inqDate",
      sortable: true,
    },
    {
      heading: "Customer Name",
      value: "customerName",
      sortable: true,
    },
    {
      heading: "Project Info",
      value: "projectName",
      sortable: true,
    },
    {
      heading: "Assigned To",
      value: "allocatedToName",
      sortable: true,
    },
    {
      heading: "Country",
      value: "countryName",
      sortable: true,
    },
    {
      value: "duration",
      label: "Duration",
      type: "dateRange",
    }
  ];

  const filterActiveEnquiries = (data) =>
    (data || []).filter((item) => item?.conversionStatus !== "Converted");

  useEffect(() => {
    if (InquiryList) setCustomerInquiryData(filterActiveEnquiries(InquiryList));
  }, [InquiryList]);

  useEffect(() => {
    let value = baseColumns.filter(({ value }) => !selected.includes(value));
    setFilterColumn(value);
  }, [selected]);

  const handleEdit = (item) => {
    if (item)
      navigate("/add-new-enquiry", {
        state: {
          row: item,
          id: item?.id,
          canAdd: menuRights?.canAdd,
          canEdit: menuRights?.canEdit,
        },
      });
  };

  const handleDelete = (item) => {
    setDeleteShow({
      show: true,
      item: item,
      title: "Do You want to delete this Enquiry?",
      textCode: "EnquiryRef",
      text: item?.inquiryRef,
      loading: false,
    });
  };

  const handleCancelDelete = () => {
    setDeleteShow({
      show: false,
      item: "",
      title: "",
      textCode: "",
      text: "",
      loading: false,
    });
  };

  const handleConfirmDelete = (item) => {
    setDeleteShow({ ...deleteShow, loading: true });
    DeleteEntry(
      "inquiry",
      item,
      setCreateMsg,
      SuccessMessages?.DELETED("Customer enquiry"),
      ErrorMessages?.DELETED_ERROR("Customer enquiry ")
    );
  };

  useEffect(() => {
    if (createMsg?.status === 200) {
      if (CheckNull(createMsg?.message) !== "") {
        setDeleteShow({ show: false, item: "", title: '', textCode: '', text: '', loading: false })
        setSuccessShow(true)
      }
    } else {
      if (CheckNull(createMsg?.message) !== "") {
        setDeleteShow({ show: false, item: "", title: '', textCode: '', text: '', loading: false })
        setErrorShow({ show: true, errorMessage: createMsg.message })
        setSuccessShow(false)
      }
    }
  }, [createMsg]);

  const ApplySearch = () => {
    let SearchResult = [];
    SearchResult = DataSearch(customerInquiryData, search, baseColumns);
    SearchResult = DataFilter(SearchResult, InquiryFilter);
    SearchResult = [...SearchResult]?.sort(function (a, b) {
      return new Date(b.createdAt) - new Date(a.createdAt);
    });
    setTableData(SearchResult);
    setRefreshSearch(false);
  };

  const handleChange = (e, index) => {
    const activeData = document.getElementById(index).checked;
    if (activeData == false) {
      setSelected((oldData) => [...oldData, e.target.value]);
    } else {
      setSelected(selected.filter((values) => values !== e.target.value));
    }
  };

  const RefreshList = () => {
    window.location.reload();
  };

  useEffect(() => {
    if (clrFilter === true) {
      ApplyFilter();
    }
  }, [clrFilter]);

  useEffect(() => {
    if (dateRange[0] != null && dateRange[1] != null) {
      const stDate = convertLocalToUTCDate(dateRange[0]).toISOString().split("T")[0];
      const etDate = convertLocalToUTCDate(dateRange[1]).toISOString().split("T")[0];
      dateRange[0] &&
        dateRange[1] &&
        setInquiryFilter({ ...InquiryFilter, dateFilter: [stDate, etDate] });
    }
  }, [dateRange]);

  const ClearFilter = () => {
    setInquiryFilter({
      projectName: [],
      customerName: [],
      distributorName: [],
      projectReference: [],
      allocatedToName: [],
      status: [],
      dateFilter: [],
    });
    setProjectName([]);
    setCustomerName([]);
    setDistributorName([]);
    setProjectReference([]);
    setStatus([]);
    setAllocatedToName([]);
    setDateRange([null, null]);
    setClrFilter(true);
  };

  const ApplyFilter = () => {
    let filterResult = [];
    filterResult = DataFilter(customerInquiryData, InquiryFilter);
    filterResult = DataSearch(filterResult, search, baseColumns);
    filterResult = [...filterResult]?.sort(function (a, b) {
      return new Date(b.createdAt) - new Date(a.createdAt);
    });
    setTableData(filterResult);
    setClrFilter(false);
  };

  useEffect(() => {
    if (refreshSearch === true || search == "") ApplySearch();
  }, [search]);

  const removeSearch = () => { setSearch(""); setRefreshSearch(true) };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      ApplySearch();
    }
  };

  const addNew = () => {
    navigate("/add-new-enquiry", {
      state: {
        canAdd: menuRights?.canAdd,
        canEdit: menuRights?.canEdit,
      },
    });
  };

  const handleView = (item) => {
    menuRights?.canView &&
      navigate("/view-enquiry", {
        state: item,
        canView: menuRights?.canView,
      });
  };

  const ErrorDoneClick = () => { setErrorShow({ show: false, errorMessage: "" }); setCreateMsg(null) }

  //successShow
  const SuccessDoneClick = () => { setSuccessShow(false); GetList("inquiry", "", setRefreshData) }

  useEffect(() => {
    if (refreshData?.message === "success") {
      setCustomerInquiryData(filterActiveEnquiries(refreshData?.data));
    }
  }, [refreshData]);
  const projectReferenceData = projectData?.map((item) => ({
    ...item,
    label: item?.ref || item?.projectCode,
    value: item?.value || item?.id,
  }));
  const hasActiveFilters = Boolean(
    projectName?.value ||
    customerName?.value ||
    distributorName?.value ||
    projectReference?.value ||
    allocatedToName?.value ||
    dateRange?.[0] ||
    dateRange?.[1]
  );


  return (
    <>
      <section className="enquiry-list-sec" id="enquiryList">
        <div className="container-fluid">
          <div className="row pt-0">
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 px-0 py-1">
              <div className="card">
                <div className="card-body">
                  <div className="row search-area-row">
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-4 col-sm-12 col-xs-12 my-auto p-0">
                      <div>
                        <p>{tableData?.length} Results Found</p>
                      </div>
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-8 col-sm-12 col-xs-12 my-auto p-0">
                      <SearchComponent
                        filteredResults={tableData}
                        search={search}
                        handleKeyDown={handleKeyPress}
                        setSearch={setSearch}
                        removeSearch={removeSearch}
                        ApplySearch={ApplySearch}
                        RefreshList={RefreshList}
                        baseColumns={baseColumns}
                        selected={selected}
                        handleChange={handleChange}
                        data={InquiryList}
                        addNew={addNew}
                        menuRights={menuRights}
                        placeholder="Search by Enquiry"
                        hasActiveFilters={hasActiveFilters}
                        filterContent={(closeFilter) => (
                          <AdvancedFilterDropdown
                            ApplyFilter={ApplyFilter}
                            ClearFilter={ClearFilter}
                            isApplyDisabled={dateRange[0] != null && dateRange[1] == null}
                            startWithFirstOnly
                            onCloseFilter={closeFilter}
                            fields={[
                              {
                                value: "projectName",
                                label: "Project Name",
                                placeholder: PlaceHolder.SELECT_PROJECT,
                                pageName: "EnquiryList",
                                dpDownName: "project",
                                data: projectData,
                                valueObject: projectName,
                                valueId: InquiryFilter?.projectName,
                                setState: setProjectName,
                                checkLabel: true,
                                onChange: (e) => {
                                  setProjectName(e);
                                  setInquiryFilter({ ...InquiryFilter, projectName: e?.label });
                                },
                              },
                              {
                                value: "customerName",
                                label: "Customer Name",
                                placeholder: PlaceHolder.SELECT_CUSTOMER,
                                pageName: "EnquiryList",
                                dpDownName: "customer",
                                data: customerList,
                                valueObject: customerName,
                                valueId: InquiryFilter?.customerName,
                                setState: setCustomerName,
                                checkLabel: true,
                                onChange: (e) => {
                                  setCustomerName(e);
                                  setInquiryFilter({ ...InquiryFilter, customerName: e?.label });
                                },
                              },
                              {
                                value: "distributorName",
                                label: "Distributor",
                                placeholder: PlaceHolder.SELECT_DISTRIBUTOR,
                                pageName: "EnquiryList",
                                dpDownName: "distributor",
                                data: distributorList,
                                valueObject: distributorName,
                                valueId: InquiryFilter?.distributorName,
                                setState: setDistributorName,
                                checkLabel: true,
                                hidden: getStorageData()?.userType === 2,
                                onChange: (e) => {
                                  setDistributorName(e);
                                  setInquiryFilter({ ...InquiryFilter, distributorName: e?.label });
                                },
                              },
                              {
                                value: "projectReference",
                                label: "Project Reference",
                                placeholder: PlaceHolder.SELECT_PROJECT,
                                pageName: "EnquiryList",
                                dpDownName: "projectreference",
                                data: projectReferenceData,
                                valueObject: projectReference,
                                valueId: InquiryFilter?.projectReference,
                                setState: setProjectReference,
                                checkLabel: true,
                                onChange: (e) => {
                                  setProjectReference(e);
                                  setInquiryFilter({ ...InquiryFilter, projectReference: e?.label });
                                },
                              },
                              {
                                value: "allocatedToName",
                                label: "Assigned Engineer",
                                placeholder: PlaceHolder.SELECT_ASSIGNED,
                                pageName: "DistributorList",
                                dpDownName: "salesengineer",
                                data: assignedEngineerData,
                                valueObject: allocatedToName,
                                valueId: InquiryFilter?.allocatedToName,
                                setState: setAllocatedToName,
                                checkLabel: true,
                                onChange: (e) => {
                                  setAllocatedToName(e);
                                  setInquiryFilter({ ...InquiryFilter, allocatedToName: e?.label });
                                },
                              },
                              {
                                value: "duration",        // MUST be string key
                                label: "Duration",
                                type: "dateRange",
                                valueObject: dateRange,
                                onChange: (val) => {
                                  const safeValue = [
                                    val?.[0] && !isNaN(new Date(val[0]).getTime()) ? val[0] : null,
                                    val?.[1] && !isNaN(new Date(val[1]).getTime()) ? val[1] : null
                                  ];

                                  setDateRange(safeValue);
                                }
                              }
                            ]}
                          />
                        )} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <EnquiryDataGrid
            filteredResults={tableData}
            filterColumn={filterColumn}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            handleView={handleView}
            menuRights={menuRights}
            moduleName="enquiry"
            loading={loadingList} />
        </div>
      </section>

      <div className="container-fluid enquiry-list-sec pl-5 pr-5">
        <EnquiryFilter
          search={search}
          setDateRange={setDateRange}
          setStatus={setStatus}
          projectData={projectData}
          setProjectData={setProjectData}
          projectName={projectName}
          customerName={customerName}
          distributorName={distributorName}
          projectReference={projectReference}
          assignedEngineerData={assignedEngineerData}
          allocatedToName={allocatedToName}
          setInquiryFilter={setInquiryFilter}
          InquiryFilter={InquiryFilter}
          setProjectName={setProjectName}
          setCustomerName={setCustomerName}
          DatePicker={DatePicker}
          dateRange={dateRange}
          ClearFilter={ClearFilter}
          ApplyFilter={ApplyFilter}
          setDistributorName={setDistributorName}
          setProjectReference={setProjectReference}
          setAllocatedToName={setAllocatedToName}
          setAssignedEngineerData={setAssignedEngineerData}
          customerInquiryData={customerInquiryData}
          ApplySearch={ApplySearch}
          setTableData={setTableData}
          menuRights={menuRights} />

        <DeleteModal deleteShow={deleteShow} handleCancelDelete={handleCancelDelete} handleConfirmDelete={handleConfirmDelete} />
        <ErrorMessage Show={errorShow?.show} errorMessage={errorShow?.errorMessage} ErrorDoneClick={ErrorDoneClick} />
        <SaveSuccessModel show={successShow} createMsg={createMsg} setShow={setSuccessShow} SuccessDoneClick={SuccessDoneClick} />
      </div>
    </>
  );
};
export default EnquiryList;
